import { useState } from "react"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"

import NumberFormat from "react-number-format"
import { ChevronDown, ChevronRight } from "lucide-react"

export const ItemsRows = ({ data, openAll, handleOpenProject }) => {
    return (
        <>
            {data?.map(it => (
                <CustomerRow
                    key={it.id}
                    it={it}
                    projects={it.projects}
                    openAll={openAll}
                    handleOpenProject={handleOpenProject}
                />
            ))}
        </>
    )
}

const CustomerRow = ({ projects, it, openAll, handleOpenProject }) => {

    const { local_simbolo, local_separacion_miles, local_separacion_decimales } = useSelector(state => state.general.info)
    const [open, setOpen] = useState(false)

    return (
        <>
            <tr>
                <th
                    className="text-start cursor-pointer flex min-w-72 border-s sticky left-[-25px] z-30 bg-white"
                    onClick={() => setOpen(!open)}
                >
                    <span className="ms-2 flex items-center">
                        {!open ?
                            <ChevronRight
                                className="h-4 w-4 text-muted-foreground shrink-0 pointer"
                            />
                            :
                            <ChevronDown
                                className="h-4 w-4 text-muted-foreground shrink-0 pointer"
                            />
                        }
                    </span>
                    <div className="ms-1 flex flex-col my-1">
                        <span className="uppercase text-[12px] text-gray-700">{it?.customer}</span>
                        <span className="text-[9px] font-semibold text-gray">{it?.detail}</span>
                    </div>
                </th>
                <th className="min-w-24">
                    <NumberFormat
                        style={{ textAlign: 'right' }}
                        displayType={'text'}
                        value={it.total_proyectado_neto || 0}
                        thousandSeparator={local_separacion_miles}
                        decimalSeparator={local_separacion_decimales}
                        prefix={`${local_simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th className="min-w-24">
                    <NumberFormat
                        displayType={'text'}
                        value={it.total_cobrado || 0}
                        thousandSeparator={local_separacion_miles}
                        decimalSeparator={local_separacion_decimales}
                        prefix={`${local_simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th className="min-w-24">
                    <NumberFormat
                        displayType={'text'}
                        value={it.total_por_cobrar || 0}
                        thousandSeparator={local_separacion_miles}
                        decimalSeparator={local_separacion_decimales}
                        prefix={`${local_simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                <th className="min-w-24">
                    <NumberFormat
                        style={{ color: (parseFloat(it?.total_late) > 0 ? 'red' : '') }}
                        displayType={'text'}
                        value={it?.total_late || 0}
                        thousandSeparator={local_separacion_miles}
                        decimalSeparator={local_separacion_decimales}
                        prefix={`${local_simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </th>
                {it?.nextMonths?.map(m => (
                    <th key={m.id} className="border-s min-w-24">
                        <NumberFormat
                            style={{ textAlign: 'right', color: m?.amount > 0 ? '#8E24AA' : '' }}
                            displayType={'text'}
                            value={m.amount || 0}
                            thousandSeparator={local_separacion_miles}
                            decimalSeparator={local_separacion_decimales}
                            prefix={`${local_simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                    </th>
                ))}
            </tr >
            {(open || openAll) && projects?.map((item, index) => (
                <ProjectsRow
                    key={index}
                    item={item}
                    handleOpenProject={handleOpenProject}
                />
            ))
            }
        </>
    )
}

const ProjectsRow = ({ item, handleOpenProject }) => {

    const { local_simbolo, local_separacion_miles, local_separacion_decimales } = useSelector(state => state.general.info)

    return (
        <tr className="bg-gray-50 cursor-pointer text-[11px] font-medium border-s">
            <td className="min-w-72 sticky left-[-25px] z-30 bg-white">
                <Link
                    to={`/ppto/${item?.id}`}
                    target="_blank"
                >
                    <p className="text-start uppercase ms-4">{item?.referencia}</p>
                </Link>
            </td>
            <td className="min-w-24">
                <NumberFormat
                    displayType={'text'}
                    value={item?.total_proyectado_neto || 0}
                    thousandSeparator={local_separacion_miles}
                    decimalSeparator={local_separacion_decimales}
                    prefix={`${local_simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            <td className="min-w-24">
                <NumberFormat
                    displayType={'text'}
                    value={item?.total_cobrado || 0}
                    thousandSeparator={local_separacion_miles}
                    decimalSeparator={local_separacion_decimales}
                    prefix={`${local_simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            <td className="min-w-24">
                <NumberFormat
                    displayType={'text'}
                    value={item?.total_por_cobrar || 0}
                    thousandSeparator={local_separacion_miles}
                    decimalSeparator={local_separacion_decimales}
                    prefix={`${local_simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            <td className="min-w-24">
                <NumberFormat
                    style={{ color: (parseFloat(item?.total_late) > 0 ? 'red' : '') }}
                    displayType={'text'}
                    value={item?.total_late || 0}
                    thousandSeparator={local_separacion_miles}
                    decimalSeparator={local_separacion_decimales}
                    prefix={`${local_simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale={2}
                />
            </td>
            {item?.nextMonths?.map(m => (
                <td key={m.id} className="border-s min-w-24">
                    <NumberFormat
                        style={{ textAlign: 'right', color: m?.amount > 0 ? '#8E24AA' : '' }}
                        displayType='text'
                        value={m?.amount || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        prefix='S/ '
                        decimalScale={2}
                        fixedDecimalScale={2}
                    />
                </td>
            ))}
        </tr>
    )
}